import { IFullPlanDetail, IFullPlanDetailPPO } from "../../interfaces/api";
import CompareStick from "./CompareStickRecommend.component";

const AllPlansFooterRecommend = ({
  plans,
}: {
  plans: IFullPlanDetail[] | IFullPlanDetailPPO[];
}) => {
  if (plans.length < 1) {
    return null;
  }
  return (
    <div className="grid-x margin-0 hide-for-small-only">
      {plans.length === 3 ? (
        <>
          <div className="cell small-3"></div>
          <div className="cell small-3">
            <CompareStick data={plans[0]} footer={true} />
          </div>
          <div className="cell small-3">
            <CompareStick data={plans[1]} footer={true} />
          </div>
          <div className="cell small-3">
            <CompareStick data={plans[2]} footer={true} />
          </div>
        </>
      ) : (
        <>
          <div className="cell small-4"></div>
          <div className="cell small-4">
            <CompareStick data={plans[0]} footer={true} />
          </div>
          <div className="cell small-4">
            <CompareStick data={plans[1]} footer={true} />
          </div>
        </>
      )}
    </div>
  );
};

export default AllPlansFooterRecommend;
